import React from "react";
import Paper from "@material-ui/core/Paper";
import Slider from "@material-ui/core/Slider";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";

import State, { SkeletonState } from "./State";
import { gql } from "apollo-boost";

const STATES_QUERY = gql`
  query listStates($trajectoryId: String!, $nextToken: String) {
    listStatesByTrajectory(trajectoryId: $trajectoryId, nextToken: $nextToken) {
      items {
        trajectoryId
        timestep
        binaryImage
      }
      nextToken
    }
  }
`;

const fetchStates = async (
  client,
  trajectoryId,
  states,
  setStates,
  nextToken,
  setNextToken
) => {
  let variables = {
    trajectoryId,
    nextToken
  };
  const queryResults = await new Promise((resolve, reject) => {
    client
      .query({
        query: STATES_QUERY,
        variables: variables
      })
      .then(result => resolve(result))
      .catch(err => reject(err));
  });

  const data = queryResults.data.listStatesByTrajectory;
  if (data.items.length === 0) {
    setNextToken(null);
  } else {
    setNextToken(data.nextToken);
    setStates(states.concat(data.items));
  }
  return;
};

function TrajectoryViewer(props) {
  const { client, trajectory, addSavedState } = props;
  const [states, setStates] = React.useState(null);
  const [nextToken, setNextToken] = React.useState(null);
  const [timestep, setTimestep] = React.useState(0);
  const trajectoryId = `${trajectory.PHI.toFixed(3)}-${trajectory.CHI.toFixed(
    3
  )}-0000`;

  React.useEffect(() => {
    setStates(null);
    setNextToken(null);
    setTimestep(0);
    return () => {
      setStates(null);
    };
  }, [trajectory]);

  React.useEffect(() => {
    if (states === null) {
      fetchStates(client, trajectoryId, [], setStates, nextToken, setNextToken);
    } else if (nextToken !== null) {
      fetchStates(
        client,
        trajectoryId,
        states,
        setStates,
        nextToken,
        setNextToken
      );
    }
  }, [client, trajectoryId, states, setStates, nextToken, setNextToken]);

  const onSliderChange = (event, value) => {
    setTimestep(value);
  };

  let state = null;
  if (states !== null && timestep < states.length) {
    state = states[timestep];
  }

  return (
    <Paper style={{ maxWidth: "500px", margin: "auto", position: "relative" }}>
      <Card style={{ padding: "10px", textAlign: "center" }}>
        {state ? <State state={state} /> : <SkeletonState />}
        <CardActions>
          <Slider
            defaultValue={0}
            value={timestep}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            step={1}
            marks
            min={0}
            max={trajectory.count - 1}
            onChange={onSliderChange}
          />
        </CardActions>
        <CardContent style={{ textAlign: "left" }}>
          <Typography color="textSecondary" gutterBottom>
            Timestep: {timestep}
          </Typography>
          <Typography color="textSecondary" gutterBottom>
            Trajectory: {trajectoryId}
          </Typography>
        </CardContent>
        {state && (
          <Tooltip title="Add State to Interpolation">
            <Fab
              style={{ position: "absolute", right: "5px", bottom: "5px" }}
              size="small"
              color="primary"
              aria-label="add"
              onClick={() => addSavedState(state)}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
        )}
      </Card>
    </Paper>
  );
}

export default TrajectoryViewer;



// WEBPACK FOOTER //
// ./src/sections/data/components/TrajectoryViewer.js